var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoulMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Vinyl-Record-Gramophone--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Vinyl Record Gramophone Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16h0.18a0.24 0.24 0 0 0 0.26 -0.2c0.49 -2.09 -1.06 -3.87 -2.68 -5.74 -2.1 -2.41 -4.48 -5.15 -3.38 -9.38a0.49 0.49 0 0 0 -0.25 -0.57 0.49 0.49 0 0 0 -0.63 0.09L4 10.9a0.51 0.51 0 0 0 0 0.62 0.53 0.53 0 0 0 0.6 0.17c3.82 -1.54 10.07 0.5 11.78 3.09a2.17 2.17 0 0 1 0.38 1A0.25 0.25 0 0 0 17 16Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22.71a0.25 0.25 0 0 1 0.25 -0.25h0.75A1.5 1.5 0 0 0 21 21v-2.5a1.5 1.5 0 0 0 -1.5 -1.5h-8.75a0.25 0.25 0 0 1 -0.25 -0.25v-0.5a0.25 0.25 0 0 1 0.25 -0.25h3a1 1 0 0 0 0 -2h-8.5a1 1 0 0 0 0 2h3a0.25 0.25 0 0 1 0.25 0.25v0.5a0.25 0.25 0 0 1 -0.25 0.25H4.5A1.5 1.5 0 0 0 3 18.46V21a1.5 1.5 0 0 0 1.5 1.5h0.75a0.25 0.25 0 0 1 0.25 0.25V23a1.1 1.1 0 0 0 0.12 0.48 1 1 0 0 0 1.76 0A1.1 1.1 0 0 0 7.5 23v-0.27a0.25 0.25 0 0 1 0.25 -0.25h8.5a0.25 0.25 0 0 1 0.25 0.25V23a1.1 1.1 0 0 0 0.12 0.48 1 1 0 0 0 1.76 0 1.1 1.1 0 0 0 0.12 -0.48Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoulMusic);
export default ForwardRef;